<template>
  <div class="authorize">
    <router-link role="button" :to="{ name: ROUTE_SHARE_BINDING, params: { hash: this.hash } }" replace>授权我们获取您的基本信息</router-link>
    <div class="text-tip">我们现在对您一无所知，必须先获取您的基本信息，才能可能为您预约到任同政教练的课时</div>
  </div>
</template>

<script>
import { ROUTE_SHARE_BINDING } from '@/router/names';

export default {
    props: {
        hash: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            ROUTE_SHARE_BINDING,
        };
    },
    methods: {
        nextStep() {
            this.$emit('next');
        },
    },
};
</script>

<style lang="scss" scoped>
@import './../../assets/scss/variables';

.authorize {
    padding: 10.666666667vw 8vw;
}

a[role=button] {
    display: block;
    height: 10.666666667vw;
    font-size: $font-size-base;
    line-height: 10.666666667vw;
    background-color: #ff3e00;
    color: white;
    text-align: center;
}

.text-tip {
    padding: 4vw 0;
    font-size: $font-size-tip;
    color: $text-color;
}
</style>



// WEBPACK FOOTER //
// src/components/share/Start.vue